module.exports = __webpack_public_path__ + "static/media/dot_F77935_a.8315a58b.svg";